module.exports = __webpack_public_path__ + "static/media/youtube.30d4b402.png";